import apiService from "./apiService";
import AppConstants from "../appConstants";

class AdobeAccountService {
    getAllAdobeAccount(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_ADOBE_ACCOUNT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    getAdobeAccountDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_ADOBE_ACCOUNT}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerAdobeAccount(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_ADOBE_ACCOUNT, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteAdobeAccount(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_ADOBE_ACCOUNT}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadFile(AppConstants.URL_ADOBE_ACCOUNT_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    resetCounter(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_ADOBE_ACCOUNT_RESET_COUNTER, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    
    // =====================================================================
    
}

export default new AdobeAccountService();
